import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const themeColors = {
  red: ['#32557c', '#791326'],
  green: ['#398a61', '#18352a'],
  greenBrown: ['#0a3c3a', '#592616'],
}

const Container = styled.div`
  background: linear-gradient(
    to right,
    ${p => themeColors[p.colorScheme][0]},
    ${p => themeColors[p.colorScheme][1]}
  );
  border-radius: ${p => p.theme.radius(10)};
  padding: ${p => p.theme.spacing(1)};
`

const Bar = styled.div.attrs({
  style: p => ({
    width: p.percentDone * 100 + '%',
  }),
})`
  background-color: #fff;
  border-radius: ${p => p.theme.spacing(10)};
  height: ${p => p.theme.fontSize(-2)};
  transition: width ${p => p.theme.transition};
`

export default class PreloadBar extends Component {
  static propTypes = {
    minPercentDone: PropTypes.number,
    percentDone: PropTypes.number,
    colorScheme: PropTypes.string.isRequired,
  }

  static defaultProps = {
    minPercentDone: 0,
    percentDone: 0,
  }

  render() {
    const { minPercentDone, percentDone, ...props } = this.props

    return (
      <Container {...props}>
        <Bar percentDone={Math.max(minPercentDone, percentDone)} />
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PreloadBar.js